// extracted by mini-css-extract-plugin
export default {"section":"or-z","sectionTitle":"pr-z","fieldWrapper":"qr-z","formField":"rr-z","disabled":"sr-z","formLabel":"tr-z"};